const mockManagement = {
  LABEL_MOCK_MANAGEMENT: 'Gestión de Mock',
  LABEL_AP_BALANCES: 'Saldos AP',
  LABEL_ARTICLE_MAPPINGS: 'Mapeos de Artículos',
  LABEL_AP_CODE: 'Código AP',
  LABEL_PLIKA_AVAILABLE: 'Disponible Plika',
  LABEL_SAP_CONSUMED: 'Consumido SAP',
  LABEL_AVAILABLE_BALANCE: 'Saldo Disponible',
  LABEL_ARTICLE_ID: 'ID de Artículo',
  LABEL_ACTIONS: 'Acciones',
  LABEL_EDIT: 'Editar',
  LABEL_DELETE: 'Eliminar',
  LABEL_SAVE: 'Guardar',
  LABEL_CANCEL: 'Cancelar',
  LABEL_REFRESH: 'Actualizar',
  LABEL_ADD_MAPPING: 'Agregar Mapeo',
  LABEL_ADD_NEW_MAPPING: 'Agregar Nuevo Mapeo',
  LABEL_PLACEHOLDER_ARTICLE_ID: 'ej., ART-12345',
  LABEL_PLACEHOLDER_AP_CODE: 'ej., AP1',
  MESSAGE_BALANCE_UPDATED: 'Saldo actualizado exitosamente',
  MESSAGE_MAPPING_SAVED: 'Mapeo guardado exitosamente',
  MESSAGE_MAPPING_DELETED: 'Mapeo eliminado exitosamente',
  MESSAGE_ERROR_UPDATE_BALANCE: 'Error al actualizar el saldo',
  MESSAGE_ERROR_SAVE_MAPPING: 'Error al guardar el mapeo',
  MESSAGE_ERROR_DELETE_MAPPING: 'Error al eliminar el mapeo',
  MESSAGE_REQUIRED_FIELDS: 'Ambos campos son requeridos',
  MESSAGE_INVALID_NUMBER: 'Por favor ingrese un número válido positivo',
  CONFIRM_DELETE_MAPPING: '¿Está seguro de que desea eliminar el mapeo para',
}

export default mockManagement
